class MonthYearPicker {
  private monthSelect: HTMLSelectElement | null
  private yearSelect: HTMLSelectElement | null
  private onChangeCallback: () => void

  constructor(onChangeCallback: () => void) {
    this.monthSelect = document.querySelector<HTMLSelectElement>('#month-select')
    this.yearSelect = document.querySelector<HTMLSelectElement>('#year-select')
    this.onChangeCallback = onChangeCallback

    this.init()
  }

  private init(): void {
    if (this.monthSelect) {
      this.monthSelect.addEventListener('change', () => this.handleChange())
    }

    if (this.yearSelect) {
      this.yearSelect.addEventListener('change', () => this.handleChange())
    }
  }

  private handleChange(): void {
    const month = this.monthSelect?.value || ''
    const year = this.yearSelect?.value || ''

    // Update or remove URL params
    this.setOrRemoveParam('rm', month)
    this.setOrRemoveParam('ry', year)

    // Fire callback to update releases
    this.onChangeCallback()
  }

  private setOrRemoveParam(key: string, value: string): void {
    const url = new URL(window.location.href)

    if (value) {
      url.searchParams.set(key, value)
    } else {
      url.searchParams.delete(key)
    }

    window.history.replaceState({}, '', url.toString())
  }
}

export default MonthYearPicker
